// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"0df3f3fc","34":"93824e93","247":"33a9f069","427":"7f560af0","453":"46dc3e92","487":"4a6b6832","577":"4266b88c","588":"4efb6ad8","636":"26ba760b","678":"42ef9c92","729":"75f7417d"}[chunkId] + ".chunk.js";
};